import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import CompactLayout from 'src/layouts/compact';
import AuthClassicLayout from 'src/layouts/auth/classic';
// components
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// Auth
const LoginPage = lazy(() => import('src/pages/auth/login'));

// ----------------------------------------------------------------------

const auth = [
  {
    path: 'login',
    element: (
      <AuthClassicLayout>
        <LoginPage />
      </AuthClassicLayout>
    ),
  },
  {
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
  },
];


export const authRoutes = [
  {
    path: 'auth',
    element: (
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
    ),
    children: [...auth /* , authAmplify, authJwt, authFirebase, authAuth0 */],
  },
];
